var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('h1',[_vm._v("Roster")]),_c('roster-calendar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }